import React, { useEffect, useState } from 'react';

const SSOLoginPage = () => {
  const [status, setStatus] = useState('processing'); // processing, success, error
  const [message, setMessage] = useState('Switching to new platform...');

  useEffect(() => {
    const handleSSO = async () => {
      // Get token from URL using plain JavaScript (no React Router needed)
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      
      if (!token) {
        setStatus('error');
        setMessage('Invalid SSO link. Please try again from the old platform.');
        return;
      }

      try {
        const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
        
        const response = await fetch(`${API_URL}/api/auth/sso-login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.detail || 'SSO login failed');
        }

        // Store the token and user info
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));

        setStatus('success');
        setMessage('Welcome to the new platform! Redirecting...');

        // Redirect to dashboard after 1 second
        setTimeout(() => {
          window.location.href = '/';
        }, 1000);

      } catch (error) {
        console.error('SSO Error:', error);
        setStatus('error');
        setMessage(error.message || 'Failed to switch platforms. Please try again.');
      }
    };

    handleSSO();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        {status === 'processing' && (
          <>
            <div className="mb-6">
              <div className="inline-block animate-spin rounded-full h-16 w-16 border-4 border-blue-500 border-t-transparent"></div>
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              Switching Platforms
            </h1>
            <p className="text-gray-600">{message}</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="mb-6">
              <div className="inline-block text-6xl">✅</div>
            </div>
            <h1 className="text-2xl font-bold text-green-600 mb-2">
              Success!
            </h1>
            <p className="text-gray-600">{message}</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="mb-6">
              <div className="inline-block text-6xl">❌</div>
            </div>
            <h1 className="text-2xl font-bold text-red-600 mb-2">
              Oops!
            </h1>
            <p className="text-gray-600 mb-6">{message}</p>
            <button
              onClick={() => window.location.href = process.env.REACT_APP_LEARNING_PLATFORM_URL || 'https://learning.cyurious.com'}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Back to Old Platform
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default SSOLoginPage;
